/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

// Routes
import paths from './paths'

function route (path, view, name, meta) {
  return {
    name: name || view,
    path,
    meta,
    component: (resovle) => import(
      `@/views/${view}.vue`
      ).then(resovle),
  }
}

Vue.use(Router)
Vue.use(Meta)

// Create a new router
const router = new Router({
  mode: 'history',
  routes: paths.map((path) => route(path.path, path.view, path.name, path.meta)).concat([
    { path: '*', redirect: '/' },
  ]),

})

router.beforeEach((to, from, next) => {
  const valid = valid_route(to, from)
  if (valid === true) {
    next()
  } else {
    next(valid)
  }
})

const valid_route = (to, from) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin)
  const access_token = localStorage.getItem('access_token')
  if (!requiresAuth) {
    return true
  }
  if (access_token === null || user == null) {
    return '/login'
  }
  if (requiresAuth && !requiresAdmin) {
    return true
  }
  if ((requiresAdmin) && user.is_admin) {
    return true
  }
    return ('/not-found')
}

export default router
